module.exports = __webpack_public_path__ + "static/media/30.be37cdc.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/30.wav
// module id = goiA
// module chunks = 0